import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
const FormikValueObserver = ({ onChange }) => {
  const { dirty } = useFormikContext();

  useEffect(() => onChange({ dirty }), [dirty, onChange]);

  return null;
};

export default FormikValueObserver;
